import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const ChangePassword = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const handleSubmit = (e) => {
    e.preventDefault();
  
  
    if (!formData.currentPassword || !formData.newPassword || !formData.confirmPassword) {
      setError("All fields are required.");
      return;
    }
  
    if (formData.newPassword !== formData.confirmPassword) {
      setError("New password and confirm password do not match.");
      return;
    }
  
    const token = Cookies.get("token"); 
    if (!token) {
      alert("Authorization required. Please login.");
      return;
    }
  
 
    fetch("https://final-project-api-alpha.vercel.app/api/auth/change-password", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, 
      },
      body: JSON.stringify({
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword,
      }),
    })
      .then((response) => {

        if (!response.ok) {
  
          throw new Error(`Error: ${response.statusText}`);
        }
        return response.json(); 
      })
      .then((data) => {
        if (data.success) {
          setSuccessMessage("Password has been changed successfully.");
          setError(""); 
      
          setTimeout(() => navigate("/dashboard"), 2000); 
        } else {
          setError(data.message || "Failed to change password. Please try again.");
        }
      })
      .catch((error) => {
        console.error("Error changing password:", error);
        setError("An error occurred while changing password.");
      });
  };
  
  return (
    <main className="flex h-full pt-20 pb-48 items-center justify-center bg-gray-50">
      <section className="w-full ml-[300px] max-w-md bg-white p-6 rounded-lg shadow-md  max-sm:ml-[60px] max-sm:bg-slate-50 max-sm:shadow-none max-sm:mt-16">
        <h2 className="text-2xl font-semibold text-indigo-700">Change Password</h2>
        {error && <div className="mt-4 text-red-500">{error}</div>}
        {successMessage && <div className="mt-4 text-green-500">{successMessage}</div>}
        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
   
          <div>
            <label className="block text-sm font-medium text-gray-700">Current Password</label>
            <input
              type="password"
              name="currentPassword"
              value={formData.currentPassword}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-md"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">New Password</label>
            <input
              type="password"
              name="newPassword"
              value={formData.newPassword}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-md"
              required
            />
          </div>

       
          <div>
            <label className="block text-sm font-medium text-gray-700">Confirm New Password</label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-md"
              required
            />
          </div>

          <div className="mt-6">
            <button
              type="submit"
              className="w-full p-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition duration-300"
            >
              Change Password
            </button>
          </div>
        </form>
      </section>
    </main>
  );
};

export default ChangePassword;
